/* eslint-disable no-unused-vars */
// src/Admin/Tabs/RaffleTickets.js
import React, { useState } from "react";
import "../Styles/RaffleTickets.css";

import RafflePurchases from "./RaffleAdmin-Tabs/Purchases";
import RaffleManualEntry from "./RaffleAdmin-Tabs/ManualEntry";
import RaffleAudit from "./RaffleAdmin-Tabs/RaffleAudit";
import PrintAllTickets from "./RaffleAdmin-Tabs/Print-all";
import { useConfig } from "../../context/ConfigContext";

const SUBTABS = [
  { id: "purchases", label: "Purchases" },
  { id: "manual", label: "Manual Entry" },
  { id: "audit", label: "Audit Log" },
  { id: "printall", label: "Print All" },
];

export default function RaffleAdminTab() {
  const [activeSubTab, setActiveSubTab] = useState("purchases");
  const { config } = useConfig();

   return (
    <div className="card-grid raffle-admin">
      <section className="card">
        <h2>🎟 Raffle Admin</h2>

        <div className="raffle-subtabs">
          <button
            className={activeSubTab === "purchases" ? "active" : ""}
            onClick={() => setActiveSubTab("purchases")}
          >
            Purchases
          </button>
          <button
            className={activeSubTab === "manual" ? "active" : ""}
            onClick={() => setActiveSubTab("manual")}
          >
            Manual Entry
          </button>
          <button
            className={activeSubTab === "audit" ? "active" : ""}
            onClick={() => setActiveSubTab("audit")}
          >
            Audit Log
          </button>
          <button
          className={activeSubTab === "printall" ? "active" : ""}
          onClick={() => setActiveSubTab("printall")}
          >
            Print All
          </button>
        </div>

        {activeSubTab === "purchases" && (
          <RafflePurchases />
        )}
        {activeSubTab === "manual" && (
          <RaffleManualEntry />
        )}
        {activeSubTab === "audit" && (
          <RaffleAudit />
        )}
        {activeSubTab === "printall" && (
          <PrintAllTickets />
        )}
      </section>
    </div>
  );
}
